




















import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";
import { fileToBase64 } from "@/utils/fileToBase64";

@Component
export default class UploadFileForm extends Vue {
  form: {
    file: File | null;
  } = {
    file: null,
  };

  get loading() {
    return $store.appearance.overlay;
  }

  set loading(val) {
    $store.appearance.overlay = val;
  }

  get elemHeight() {
    return $store.appearance.appHeight;
  }

  async nextStep() {
    if (this.form.file) {
      this.loading = true;
      // 1. Convert file to base64 string
      const encodedFile = await fileToBase64(this.form.file);
      // 2. Create layout source
      const [layoutSource, err] = await $store.layoutSources.create({
        storageObject: {
          contentType: "application/pdf",
          fileName: this.form.file.name,
          data: encodedFile,
        },
      });
      this.loading = false;
      if (!layoutSource) {
        console.log(err);
        //TODO Show error alert
      } else {
        $store.wizard.layoutStep = 2;
      }
    }
  }
}
